// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const MyIdeas = zod.object({
  "runs_requested": zod.int(),
  "total": zod.int(),
  "verdict_counts": zod.record(zod.string(), zod.int())
});

export type MyIdeas = zod.input<typeof MyIdeas>;
export type MyIdeasOutput = zod.output<typeof MyIdeas>;
